import { useMemo } from "react";
import type { NurseResponse } from "@vTypes/nurse-type";
import type { PreceptorGroupID } from "@vTypes/roster.types";
import { filterPreceptorList } from "@utils/filter-preceptorlist";

export function usePreceptorMapping(fullNurseSchema: NurseResponse[]) {
  const preceptorGroupID: PreceptorGroupID[] = useMemo(() => {
    const preceptorMap = new Map<string, string[]>();

    fullNurseSchema.forEach((nurse) => {
      const preceptorID = nurse.preceptor_id;
      const nurseID = nurse.nurse_id;
      if (preceptorID) {
        if (!preceptorMap.has(preceptorID)) {
          preceptorMap.set(preceptorID, []);
        }
        preceptorMap.get(preceptorID)!.push(nurseID);
      }
    });

    return Array.from(preceptorMap.entries()).map(([preceptor, preceptee]) => ({
      preceptor,
      preceptee,
    }));
  }, [fullNurseSchema]);

  const preceptorList = useMemo(
    () => filterPreceptorList(fullNurseSchema, preceptorGroupID),
    [fullNurseSchema, preceptorGroupID]
  );

  return { preceptorGroupID, preceptorList };
}
